/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import {connect} from 'react-redux';

import IconSelect from '../IconSelect';
import '../../styles/SmallModal.css';

class IconSelectModal extends Component {
  render() {
    const {modal} = this.props; 

    const componentType = modal.getIn(['options', 'componentType']);
    const componentId = modal.getIn(['options', 'componentId']);

    return <div className="fs-modal-content iconselect-select-modal">
      <h4>Icon Select</h4>
      <IconSelect componentType={componentType} componentId={componentId} />
    </div>
  }
}

const modalSelector = (state, props) => {
  return state.modal.get('modals').last();
}

const IconSelectModalContainerSelector = immutableCreatorSelector(
  [modalSelector],
  (modal) => {
    return {
      modal
    };
  }
)
@connect(IconSelectModalContainerSelector)
export default
class IconSelectModalContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  render() {
    return (
      <IconSelectModal  
        {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/IconSelectModal.js